import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";

import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RefreshIcon from "@mui/icons-material/Refresh";

import PageContainer from "components/templates/PageContainer";
import ReportLocationHourWeekTable from "components/molecules/table/ReportLocationHourWeekTable";
import InfoTooltip from "components/atoms/info/InfoTooltip";
import SelectBlock from "components/atoms/select/SelectBlock";
import SelectLocation from "components/atoms/select/SelectLocation";
import SelectUnit from "components/atoms/select/SelectUnit";
import SelectActivityType from "components/atoms/select/SelectActivityType";
import ButtonDatePicker from "components/atoms/dateTime/ButtonDatePicker";
import ButtonTimePicker from "components/atoms/dateTime/ButtonTimePicker";
import {
  getFormattedTime,
  getFormattedTimeHour,
  getMinTime,
  getMaxTime,
} from "components/atoms/dateTime/GetFormattedDate";

const ReportLocationHourWeek = () => {
  const [unit, setUnit] = useState(null);
  const [activityType, setActivityType] = useState(null);
  const [block, setBlock] = useState(null);
  const [location, setLocation] = useState(null);
  const [dateReservation, setDateReservation] = useState(new Date());
  const [dateBegin, setDateBegin] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);

  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const blockCallback = (childData) => {
    locationCallback(null);
    setBlock(childData);
  };

  const locationCallback = (childData) => {
    setLocation(childData);
  };

  const unitCallback = (childData) => {
    setUnit(childData);
  };

  const activityTypeCallback = (childData) => {
    setActivityType(childData);
  };

  const handleChangeDateReservation = (newValue) => {
    setDateReservation(newValue);
  };

  const handleChangeDateBegin = (newValue) => {
    setDateBegin(newValue);
  };

  const handleChangeDateEnd = (newValue) => {
    setDateEnd(newValue);
  };

  const getDateEnd = () => {
    const hour = String(Number(getFormattedTimeHour(dateBegin)) + 1);

    return hour;
  };

  const handleClean = (event) => {
    blockCallback(null);
    locationCallback(null);
    unitCallback(null);
    activityTypeCallback(null);
    setDateReservation(new Date());
    setDateBegin(null);
    setDateEnd(null);
  };

  return (
    <PageContainer
      maxWidth="lg"
      title={"Carga Horária Diária do Local"}
      icon={<AccessTimeIcon />}
    >
      <Box id="ControlButtons" sx={{ mt: 4 }}>
        <InfoTooltip placement="top-start" title="Voltar">
          <IconButton onClick={handleBack}>
            <ArrowBackIcon />
          </IconButton>
        </InfoTooltip>
        <InfoTooltip title="Reiniciar filtros" placement="top">
          <IconButton variant="contained" onClick={handleClean}>
            <RefreshIcon />
          </IconButton>
        </InfoTooltip>
      </Box>
      <Box>
        <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item xs={12} lg={6}>
            <SelectBlock
              dataParentToChild={block}
              parentCallback={blockCallback}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <SelectLocation
              idBlock={block ? block.id : 0}
              dataParentToChild={location}
              parentCallback={locationCallback}
            />
          </Grid>
          <Grid item>
            <ButtonDatePicker
              value={dateReservation}
              onChange={handleChangeDateReservation}
              id="dateReservation"
              label="Data das Reservas"
              name="dateReservation"
              sx={{ mt: 1 }}
            />
          </Grid>
          <Grid item sx={{ display: "inline-flex", mt: 1 }}>
            <Box sx={{ mr: 2 }}>
              <ButtonTimePicker
                id={"dateBegin"}
                views={["hours"]}
                skipDisabled
                minTime={getMinTime("07")}
                maxTime={getMaxTime("21")}
                value={dateBegin}
                label={
                  dateBegin == null
                    ? "Hora Início"
                    : `Hora Início: ${getFormattedTimeHour(dateBegin)}`
                }
                onChange={handleChangeDateBegin}
              />
            </Box>
            <ButtonTimePicker
              disable
              id={"dateEnd"}
              views={["hours"]}
              disabled={!dateBegin}
              skipDisabled
              minTime={dateBegin && getMinTime(getDateEnd())}
              maxTime={getMaxTime("22")}
              value={dateEnd}
              label={
                dateEnd == null
                  ? "Hora Fim"
                  : `Hora Fim: ${getFormattedTimeHour(dateEnd)}`
              }
              onChange={handleChangeDateEnd}
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <SelectUnit
              dataParentToChild={unit}
              parentCallback={unitCallback}
            />
          </Grid>
          <Grid item xs={12} lg={3}>
            <SelectActivityType
              dataParentToChild={activityType}
              parentCallback={activityTypeCallback}
            />
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ mt: 2 }}>
        <ReportLocationHourWeekTable
          idLocation={location ? location.id : ""}
          date={dateReservation}
          idUnit={unit && unit.id}
          idActivityType={activityType && activityType.id}
          hourBegin={dateBegin && getFormattedTime(dateBegin)}
          hourEnd={dateEnd && getFormattedTime(dateEnd)}
        />
      </Box>
    </PageContainer>
  );
};

export default ReportLocationHourWeek;
